import { BaseMenuItem } from "./base-menu-item";
import { types } from "./menu-item-types";

export class HyperlinkMenuItem extends BaseMenuItem {
    constructor(icon, href, onclick = () => {}) {
        super(types.hyperlink, icon);
        this.href = href;
        this.onclick = onclick;
    }
}